export default "__VITE_ASSET__DQer07gT__"